export default __webpack_public_path__ + "images/5a83f4d5c6ab1503003308e792096fc8-cycle-countP.svg";